module.exports = __webpack_public_path__ + "img/topBanner.2f6afc84.png";